module.exports = __webpack_public_path__ + "media/images/wedding/22-c9ad7167371962279725a1799f475b27.jpg";